import { useState, useEffect } from "react";

import Spinner from "../../spinners/DataSpinner";

import axios from "axios";

import { Link } from "react-router-dom";

const ViewCategories = () => {
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        let isMounted = true;
        axios.get(`api/get-categories`)
            .then(res => {
                if (res.data.status === 200) {
                    setCategories(res.data.categories);
                }
                setLoading(false);
            });

        return () => {
            isMounted = false;
        }
    }, []);

    if (loading) {
        return <Spinner />
    } else {
        var categoryList = "";
        categoryList = categories.map((item) => {
            return (
                <div className="col" key={item.id}>
                    <div className="card shadow-sm border-0">
                        <div className="card-body">
                            <h2 className="card-text text-center mb-3 mt-3">{item.name}</h2>
                            <div className="d-flex justify-content-center align-items-center">
                                <Link type="button" className="btn btn-md btn-primary" to={`/collections/${item.slug}`}>
                                    View Products
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <div className="album py-5 bg-light">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">Collections</li>
                    </ol>
                </nav>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                    {categoryList}
                </div>
            </div>
        </div>
    );
}

export default ViewCategories;